import { isBlockedOrganizationAccount } from '~/utils/userAccountType'
import { isImpersonationCallbackPath } from '~/utils/impersonationRoute'
import { onboardingRedirectPath } from '~/utils/onboardingRoute'

export default async function({ store, redirect, route, from }) {
	const user = store.getters['user/user']

	if (user && user.type == 'applicant') {
		const fromImpersonation = isImpersonationCallbackPath(from.path)
		const applicantProfile = fromImpersonation
			? user.applicant_profile
			: await store.dispatch('applicantProfile/needApplicantProfile')

		if (!applicantProfile) {
			return redirect(200, '/welcome')
		}

		// Keep applicants in onboarding (personality, then setup) until the
		// profile is active. This middleware is not on the setup/assessment
		// pages, so there is no redirect loop.
		const onboardingPath = onboardingRedirectPath(applicantProfile)
		if (onboardingPath) {
			return redirect(200, onboardingPath)
		}
	}

	if (
		user &&
		user.type == 'organization_member' &&
		!user.current_organization
	) {
		return redirect(
			200,
			isBlockedOrganizationAccount(user)
				? '/organization-unavailable'
				: '/organization-create'
		)
	}
}
